<template>
  <Modal
    content-class="q-pa-lg"
    header-class="q-pa-md"
    :modal-style="modalStyle"
    :title="getLocaleText('outreach_pitch.create_pitch')"
    @close="close"
  >
    <div class="modal-content">
      <OutreachContactListDropdown v-model="selectedList" />
    </div>

    <template #buttons>
      <div class="modal-buttons">
        <div>
          <BaseButton
            v-if="isDesktop"
            data-testid="cancel-button"
            :disabled="saving"
            :label="getLocaleText('outreach.media_release.cancel')"
            new-design
            @click.prevent="close"
          />
          <BaseButton
            :aria-label="getLocaleText('outreach.media_release.create')"
            color="primary"
            data-testid="save-button"
            :disabled="!isValid"
            :label="getLocaleText('outreach.media_release.create')"
            :loading="saving"
            new-design
            @click="save"
          />
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, inject, ref } from "vue";

import { ErrorDialog } from "shared/boot/alert";
import { getLocaleText } from "shared/boot/i18n";
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";
import OutreachContactListDropdown from "shared/components/OutreachContactListDropdown.vue";
import { useCreateOutreachPitch } from "shared/composables/useCreateOutreachPitch";

import ModalService from "./ModalService";

const props = defineProps<{
  prompt?: string;
}>();

const isDesktop = inject("isDesktop");

const saving = ref(false);

const modalStyle = computed(() => {
  if (isDesktop) {
    return { width: "460px" };
  }

  return {};
});

const selectedList = ref();

const isValid = computed(() => Boolean(selectedList.value));

function close() {
  ModalService.close("CreateOutreachPitchModal");
}

const { createOutreachPitchWithContactList } = useCreateOutreachPitch();

async function save() {
  if (!isValid.value) return;

  try {
    saving.value = true;

    await createOutreachPitchWithContactList(selectedList.value, props.prompt);
  } catch (error) {
    ErrorDialog(getLocaleText("outreach_pitch.error_creating_pitch"), error);
  } finally {
    saving.value = false;
    close();
  }
}
</script>

<style lang="scss" scoped>
:deep(.streem-modal2-buttons) {
  padding: 16px 24px 16px 0 !important;
}
</style>
